import session from '../../auth_api/session'
import Vue from 'vue'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'reporting/api/'
const appURLAccounts = URL + 'auth/api/'

export default {
  namespaced: true,
  state: {
    reports: { 'results': [] },
    report_search: { period: '', status_id: null, department: '' },
    statuses: [],
    types: [],
    report: {},
    mum_divisions: {
      '1083808001023': [
        'МУМ № 1 по Бодайбинскому району',
        'МУМ № 1 по г. Иркутску',
        'Отдел опеки и попечительства граждан по Иркутскому району МУМ № 1',
        'МУМ № 1 по Катангскому району',
        'Отдел опеки и попечительства граждан по Киренскому району МУМ № 1',
        'МУМ № 1 по Мамско-Чуйскому району',
        'Отдел опеки и попечительства граждан по Шелеховскому району МУМ № 1',
        'Отдел опеки и попечительства граждан по Слюдянскому району МУМ № 1'
      ],
      '1043802464452': [
        'Отдел опеки и попечительства граждан по Баяндаевскому и Ольхонскому районам МУМ № 2 (Баяндаевский район)',
        'Отдел опеки и попечительства граждан по Эхирит-Булагатскому району МУМ № 2',
        'Отдел опеки и попечительства граждан по Качугскому и Жигаловскому районам МУМ № 2 (Качугский район)',
        'Отдел опеки и попечительства граждан по Баяндаевскому и Ольхонскому районам МУМ № 2 (Ольхонский район)',
        'Отдел опеки и попечительства граждан по Качугскому и Жигаловскому районам МУМ № 2 (Жигаловский район)'
      ],
      '1043801917026': [
        'Отдел опеки и попечительства граждан по Заларинскому, Аларскому и Нукутскому районам МУМ № 3 (Аларский район)',
        'Отдел опеки и попечительства граждан по Усть-Удинскому и Балаганскому районам МУМ № 3 (Балаганский район)',
        'Отдел опеки и попечительства граждан по Боханскому и Осинскому районам МУМ № 3 (Боханский район)',
        'Отдел опеки и попечительства граждан по Заларинскому, Аларскому и Нукутскому районам МУМ № 3 (Нукутский район)',
        'Отдел опеки и попечительства граждан по Боханскому и Осинскому районам МУМ № 3 (Осинский район)',
        'Отдел опеки и попечительства граждан по Усть-Удинскому и Балаганскому районам МУМ № 3 (Усть-Удинский район)',
        'Отдел опеки и попечительства граждан по Заларинскому, Аларскому и Нукутскому районам МУМ № 3 (Заларинский район)'
      ],
      '1043802220670': [
        'Отдел опеки и попечительства граждан по Ангарскому району МУМ № 4',
        'Отдел опеки и попечительства граждан по г. Черемхово, г. Свирску и Черемховскому районам МУМ № 4 (г. Черемхово)',
        'Отдел опеки и попечительства граждан по г. Черемхово, г. Свирску и Черемховскому районам МУМ № 4 (Черемховский район)',
        'Отдел опеки и попечительства граждан по г. Черемхово, г. Свирску и Черемховскому районам МУМ № 4 (г. Свирск)',
        'Отдел опеки и попечительства граждан по г. Усолье-Сибирское и Усольскому району МУМ № 4 (г. Усолье-Сибирское)',
        'Отдел опеки и попечительства граждан по г. Усолье-Сибирское и Усольскому району МУМ № 4 (Усольский район)'
      ],
      '1043801972532': [
        'Отдел опеки и попечительства граждан по Куйтунскому району МУМ № 5',
        'Отдел опеки и попечительства граждан по г. Саянску МУМ № 5',
        'Отдел опеки и попечительства граждан по г. Тулуну и Тулунскому району МУМ № 5 (г. Тулун)',
        'Отдел опеки и попечительства граждан по г. Тулуну и Тулунскому району МУМ № 5 (Тулунский район)',
        'Отдел опеки и попечительства граждан по г. Зиме и Зиминскому району МУМ № 5 (г. Зима)',
        'Отдел опеки и попечительства граждан по г. Зиме и Зиминскому району МУМ № 5 (Зиминский район)'
      ],
      '1043801946825': [
        'Отдел опеки и попечительства граждан по Чунскому району МУМ № 6',
        'Отдел опеки и попечительства граждан по Нижнеудинскому району МУМ № 6',
        'Отдел опеки и попечительства граждан по Тайшетскому району МУМ № 6'
      ],
      '1043800850664': [
        'Отдел опеки и попечительства граждан по г. Братску МУМ № 7',
        'Отдел опеки и попечительства граждан по Братскому району МУМ № 7',
        'Отдел опеки и попечительства граждан по Казачинско-Ленскому району МУМ № 7',
        'Отдел опеки и попечительства граждан по Нижнеилимскому району МУМ № 7',
        'Отдел опеки и попечительства граждан по г. Усть-Илимску и Усть-Илимскому району МУМ № 7 (г. Усть-Илимск)',
        'Отдел опеки и попечительства граждан по г. Усть-Илимску и Усть-Илимскому району МУМ № 7 (Усть-Илимский район)',
        'Отдел опеки и попечительства граждан по г. Усть-Куту и Усть-Кутскому району МУМ № 7'
      ]
    },
    defaultReport: {
      id: null,
      period: new Date().toISOString().substr(0, 8) + '01',
      status: 1,
      typeAbbr: '',
      data: {},
      remark: '',
      date_created: null,
      date_of_change: null,
      department: null,
      user: null,
      self_department: true
    },
    defaultData_monitoring_msss_02: {
      table1:
      [{
        department: '',
        service: 'Предоставление гражданам субсидий на оплату жилых помещений и коммунальных услуг',
        coll_1: null,
        coll_2: null,
        coll_3: null,
        coll_4: null,
        coll_5: null,
        coll_6: null,
        coll_7: null
      }
      ]
    },
    defaultData_one_001: {
      table1:
        [{
          department: '',
          coll_1: null,
          coll_2: null,
          coll_3: null,
          coll_4: null,
          coll_5: null,
          coll_6: null,
          coll_7: null
        }
        ]
    },
    defaultData_form_001: {
      dict1:
        {
          department: '',
          mum_division: '',
          row_1: null,
          row_1_1: null,
          row_1_2: null,
          row_1_3: null,
          row_1_3_1: null,
          row_1_3_2: null,
          row_1_3_3: null,
          row_1_4: null,
          row_2: null,
          row_2_1: null,
          row_2_2: null,
          row_2_3: null,
          row_3: null,
          row_4: null,
          row_4_1: null,
          row_4_2: null,
          row_4_3: null,
          row_4_4: null,
          row_4_5: null,
          row_4_6: null,
          row_4_7: null,
          row_4_8: null,
          row_5: null,
          row_5_1: null,
          row_5_2: null,
          row_5_3: null,
          row_5_4: null,
          row_5_5: null,
          row_5_6: null,
          row_5_7: null,
          row_5_8: null,
          row_6: null,
          row_6_1: null,
          row_6_2: null,
          row_6_3: null,
          row_6_4: null,
          row_7: null,
          row_7_1: null,
          row_7_2: null,
          row_7_3: null,
          row_8: null,
          row_8_1: null,
          row_8_2: null,
          row_8_2_1: null,
          row_8_2_2: null,
          row_8_2_3: null,
          row_9: null,
          row_9_1: null,
          row_10: null,
          row_10_1: null,
          row_11: null,
          row_11_1: null,
          row_12: null,
          row_12_1: null,
          row_13: null,
          row_13_1: null,
          row_13_2: null,
          row_13_3: null
        }
    },
    defaultData_form_002: {
      dict1:
        {
          department: '',
          mum_division: '',
          row_1: null,
          row_1_1: null,
          row_1_2: null,
          row_1_3: null,
          row_1_4: null,
          row_2: null,
          row_2_1: null,
          row_2_1_1: null,
          row_2_1_2: null,
          row_2_1_3: null,
          row_2_1_4: null,
          row_2_1_5: null,
          row_2_2: null,
          row_2_2_1: null,
          row_2_2_2: null,
          row_2_2_3: null,
          row_2_3: null,
          row_3: null,
          row_3_1: null,
          row_3_2: null,
          row_3_3: null,
          row_4: null,
          row_4_1: null,
          row_4_2: null,
          row_4_3: null,
          row_5: null,
          row_6: null,
          row_6_1: null,
          row_6_2: null,
          row_6_3: null,
          row_7: null,
          row_7_1: null,
          row_7_2: null,
          row_8: null,
          row_9: null,
          row_10: null,
          row_10_1: null,
          row_10_2: null,
          row_10_2_1: null,
          row_10_2_2: null,
          row_10_2_3: null,
          row_11: null
        }
    },
    defaultData_form_003: {
      dict1:
        {
          department: '',
          mum_division: '',
          row_1: null,
          row_1_1: null,
          row_1_1_1: null,
          row_1_1_2: null,
          row_1_1_3: null,
          row_1_1_4: null,
          row_1_2: null,
          row_1_2_1: null,
          row_1_2_2: null,
          row_1_2_3: null,
          row_1_2_4: null,
          row_1_3: null,
          row_1_3_1: null,
          row_1_3_2: null,
          row_1_3_3: null,
          row_1_3_4: null,
          row_2: null,
          row_3: null,
          row_3_1: null,
          row_3_2: null,
          row_3_3: null,
          row_4: null,
          row_4_1: null,
          row_4_2: null,
          row_5: null,
          row_5_1: null,
          row_5_2: null,
          row_5_3: null
        }
    },
    defaultData_it_001: {
      dict2:
        {
          row_1_4: null,
          row_1_5: [],
          row_1_6: null,
          row_1_7: [],
          row_2_4: null,
          row_2_5: [],
          row_2_6: null,
          row_2_7: [],
          row_3_4: null,
          row_3_5: [],
          row_3_6: null,
          row_3_7: [],
          row_4_4: null,
          row_4_5: [],
          row_4_6: null,
          row_4_7: [],
          meta:
            {
              add: ['row_1_4', 'row_1_6', 'row_2_4', 'row_2_6', 'row_3_4', 'row_3_6', 'row_4_4', 'row_4_6'],
              set: ['row_1_5', 'row_1_7', 'row_2_5', 'row_2_7', 'row_3_5', 'row_3_7', 'row_4_5', 'row_4_7']
            }
        }
    },
    defaultData_it_002: {
      dict2:
        {
          t1r_123_4: null,
          t1r_123_5: null,
          t1r_124_4: null,
          t1r_124_5: null,
          t2r_111_1: null,
          t2r_111_2: null,
          t2r_111_3: null,
          t2r_111_4: null,
          t2r_112_1: null,
          t2r_112_2: null,
          t2r_112_3: null,
          t2r_112_4: null,
          t2r_121_1: null,
          t2r_121_2: null,
          t2r_121_3: null,
          t2r_121_4: null,
          t2r_122_1: null,
          t2r_122_2: null,
          t2r_122_3: null,
          t2r_122_4: null,
          t2r_131_1: null,
          t2r_131_2: null,
          t2r_131_3: null,
          t2r_131_4: null,
          t2r_132_1: null,
          t2r_132_2: null,
          t2r_132_3: null,
          t2r_132_4: null,
          t2r_141_1: null,
          t2r_141_2: null,
          t2r_141_3: null,
          t2r_141_4: null,
          t2r_142_1: null,
          t2r_142_2: null,
          t2r_142_3: null,
          t2r_142_4: null,
          t2r_211_1: null,
          t2r_211_2: null,
          t2r_211_3: null,
          t2r_211_4: null,
          t2r_212_1: null,
          t2r_212_2: null,
          t2r_212_3: null,
          t2r_212_4: null,
          t2r_221_1: null,
          t2r_221_2: null,
          t2r_221_3: null,
          t2r_221_4: null,
          t2r_222_1: null,
          t2r_222_2: null,
          t2r_222_3: null,
          t2r_222_4: null,
          t2r_231_1: null,
          t2r_231_2: null,
          t2r_231_3: null,
          t2r_231_4: null,
          t2r_232_1: null,
          t2r_232_2: null,
          t2r_232_3: null,
          t2r_232_4: null,
          t2r_241_1: null,
          t2r_241_2: null,
          t2r_241_3: null,
          t2r_241_4: null,
          t2r_242_1: null,
          t2r_242_2: null,
          t2r_242_3: null,
          t2r_242_4: null,
          t2r_251_1: null,
          t2r_251_2: null,
          t2r_251_3: null,
          t2r_251_4: null,
          t2r_252_1: null,
          t2r_252_2: null,
          t2r_252_3: null,
          t2r_252_4: null,
          t2r_261_1: null,
          t2r_261_2: null,
          t2r_261_3: null,
          t2r_261_4: null,
          t2r_262_1: null,
          t2r_262_2: null,
          t2r_262_3: null,
          t2r_262_4: null,
          t2r_271_1: null,
          t2r_271_2: null,
          t2r_271_3: null,
          t2r_271_4: null,
          t2r_272_1: null,
          t2r_272_2: null,
          t2r_272_3: null,
          t2r_272_4: null,
          t2r_281_1: null,
          t2r_281_2: null,
          t2r_281_3: null,
          t2r_281_4: null,
          t2r_282_1: null,
          t2r_282_2: null,
          t2r_282_3: null,
          t2r_282_4: null,
          t2r_311_1: null,
          t2r_311_2: null,
          t2r_311_3: null,
          t2r_311_4: null,
          t2r_312_1: null,
          t2r_312_2: null,
          t2r_312_3: null,
          t2r_312_4: null,
          t2r_321_1: null,
          t2r_321_2: null,
          t2r_321_3: null,
          t2r_321_4: null,
          t2r_322_1: null,
          t2r_322_2: null,
          t2r_322_3: null,
          t2r_322_4: null,
          meta:
            {
              add: ['t1r_123_4', 't1r_123_5', 't1r_124_4', 't1r_124_5', 't2r_111_1', 't2r_111_2', 't2r_111_3', 't2r_111_4', 't2r_112_1', 't2r_112_2', 't2r_112_3', 't2r_112_4', 't2r_121_1', 't2r_121_2', 't2r_121_3', 't2r_121_4', 't2r_122_1', 't2r_122_2', 't2r_122_3', 't2r_122_4', 't2r_131_1', 't2r_131_2', 't2r_131_3', 't2r_131_4', 't2r_132_1', 't2r_132_2', 't2r_132_3', 't2r_132_4', 't2r_141_1', 't2r_141_2', 't2r_141_3', 't2r_141_4', 't2r_142_1', 't2r_142_2', 't2r_142_3', 't2r_142_4', 't2r_211_1', 't2r_211_2', 't2r_211_3', 't2r_211_4', 't2r_212_1', 't2r_212_2', 't2r_212_3', 't2r_212_4', 't2r_221_1', 't2r_221_2', 't2r_221_3', 't2r_221_4', 't2r_222_1', 't2r_222_2', 't2r_222_3', 't2r_222_4', 't2r_231_1', 't2r_231_2', 't2r_231_3', 't2r_231_4', 't2r_232_1', 't2r_232_2', 't2r_232_3', 't2r_232_4', 't2r_241_1', 't2r_241_2', 't2r_241_3', 't2r_241_4', 't2r_242_1', 't2r_242_2', 't2r_242_3', 't2r_242_4', 't2r_251_1', 't2r_251_2', 't2r_251_3', 't2r_251_4', 't2r_252_1', 't2r_252_2', 't2r_252_3', 't2r_252_4', 't2r_261_1', 't2r_261_2', 't2r_261_3', 't2r_261_4', 't2r_262_1', 't2r_262_2', 't2r_262_3', 't2r_262_4', 't2r_271_1', 't2r_271_2', 't2r_271_3', 't2r_271_4', 't2r_272_1', 't2r_272_2', 't2r_272_3', 't2r_272_4', 't2r_281_1', 't2r_281_2', 't2r_281_3', 't2r_281_4', 't2r_282_1', 't2r_282_2', 't2r_282_3', 't2r_282_4', 't2r_311_1', 't2r_311_2', 't2r_311_3', 't2r_311_4', 't2r_312_1', 't2r_312_2', 't2r_312_3', 't2r_312_4', 't2r_321_1', 't2r_321_2', 't2r_321_3', 't2r_321_4', 't2r_322_1', 't2r_322_2', 't2r_322_3', 't2r_322_4']
            }
        }
    },
    defaultData_it_003: {
      dict2:
        {
          row_111_1_1: null,
          row_111_1_2: [],
          row_111_2_1: null,
          row_111_2_2: [],
          row_111_3_1: null,
          row_111_3_2: [],
          row_111_4_1: null,
          row_111_4_2: [],

          row_112_1_1: null,
          row_112_1_2: [],
          row_112_2_1: null,
          row_112_2_2: [],
          row_112_3_1: null,
          row_112_3_2: [],
          row_112_4_1: null,
          row_112_4_2: [],

          row_121_1_1: null,
          row_121_1_2: [],
          row_121_2_1: null,
          row_121_2_2: [],
          row_121_3_1: null,
          row_121_3_2: [],
          row_121_4_1: null,
          row_121_4_2: [],

          row_122_1_1: null,
          row_122_1_2: [],
          row_122_2_1: null,
          row_122_2_2: [],
          row_122_3_1: null,
          row_122_3_2: [],
          row_122_4_1: null,
          row_122_4_2: [],

          row_131_1_1: null,
          row_131_1_2: [],
          row_131_2_1: null,
          row_131_2_2: [],
          row_131_3_1: null,
          row_131_3_2: [],
          row_131_4_1: null,
          row_131_4_2: [],

          row_132_1_1: null,
          row_132_1_2: [],
          row_132_2_1: null,
          row_132_2_2: [],
          row_132_3_1: null,
          row_132_3_2: [],
          row_132_4_1: null,
          row_132_4_2: [],

          row_141_1_1: null,
          row_141_1_2: [],
          row_141_2_1: null,
          row_141_2_2: [],
          row_141_3_1: null,
          row_141_3_2: [],
          row_141_4_1: null,
          row_141_4_2: [],

          row_142_1_1: null,
          row_142_1_2: [],
          row_142_2_1: null,
          row_142_2_2: [],
          row_142_3_1: null,
          row_142_3_2: [],
          row_142_4_1: null,
          row_142_4_2: [],

          row_211_1_1: null,
          row_211_1_2: [],
          row_211_2_1: null,
          row_211_2_2: [],
          row_211_3_1: null,
          row_211_3_2: [],
          row_211_4_1: null,
          row_211_4_2: [],

          row_212_1_1: null,
          row_212_1_2: [],
          row_212_2_1: null,
          row_212_2_2: [],
          row_212_3_1: null,
          row_212_3_2: [],
          row_212_4_1: null,
          row_212_4_2: [],

          row_221_1_1: null,
          row_221_1_2: [],
          row_221_2_1: null,
          row_221_2_2: [],
          row_221_3_1: null,
          row_221_3_2: [],
          row_221_4_1: null,
          row_221_4_2: [],

          row_222_1_1: null,
          row_222_1_2: [],
          row_222_2_1: null,
          row_222_2_2: [],
          row_222_3_1: null,
          row_222_3_2: [],
          row_222_4_1: null,
          row_222_4_2: [],

          row_231_1_1: null,
          row_231_1_2: [],
          row_231_2_1: null,
          row_231_2_2: [],
          row_231_3_1: null,
          row_231_3_2: [],
          row_231_4_1: null,
          row_231_4_2: [],

          row_232_1_1: null,
          row_232_1_2: [],
          row_232_2_1: null,
          row_232_2_2: [],
          row_232_3_1: null,
          row_232_3_2: [],
          row_232_4_1: null,
          row_232_4_2: [],

          row_241_1_1: null,
          row_241_1_2: [],
          row_241_2_1: null,
          row_241_2_2: [],
          row_241_3_1: null,
          row_241_3_2: [],
          row_241_4_1: null,
          row_241_4_2: [],

          row_242_1_1: null,
          row_242_1_2: [],
          row_242_2_1: null,
          row_242_2_2: [],
          row_242_3_1: null,
          row_242_3_2: [],
          row_242_4_1: null,
          row_242_4_2: [],

          row_251_1_1: null,
          row_251_1_2: [],
          row_251_2_1: null,
          row_251_2_2: [],
          row_251_3_1: null,
          row_251_3_2: [],
          row_251_4_1: null,
          row_251_4_2: [],

          row_252_1_1: null,
          row_252_1_2: [],
          row_252_2_1: null,
          row_252_2_2: [],
          row_252_3_1: null,
          row_252_3_2: [],
          row_252_4_1: null,
          row_252_4_2: [],

          row_261_1_1: null,
          row_261_1_2: [],
          row_261_2_1: null,
          row_261_2_2: [],
          row_261_3_1: null,
          row_261_3_2: [],
          row_261_4_1: null,
          row_261_4_2: [],

          row_262_1_1: null,
          row_262_1_2: [],
          row_262_2_1: null,
          row_262_2_2: [],
          row_262_3_1: null,
          row_262_3_2: [],
          row_262_4_1: null,
          row_262_4_2: [],

          row_271_1_1: null,
          row_271_1_2: [],
          row_271_2_1: null,
          row_271_2_2: [],
          row_271_3_1: null,
          row_271_3_2: [],
          row_271_4_1: null,
          row_271_4_2: [],

          row_272_1_1: null,
          row_272_1_2: [],
          row_272_2_1: null,
          row_272_2_2: [],
          row_272_3_1: null,
          row_272_3_2: [],
          row_272_4_1: null,
          row_272_4_2: [],

          row_281_1_1: null,
          row_281_1_2: [],
          row_281_2_1: null,
          row_281_2_2: [],
          row_281_3_1: null,
          row_281_3_2: [],
          row_281_4_1: null,
          row_281_4_2: [],

          row_282_1_1: null,
          row_282_1_2: [],
          row_282_2_1: null,
          row_282_2_2: [],
          row_282_3_1: null,
          row_282_3_2: [],
          row_282_4_1: null,
          row_282_4_2: [],

          row_311_1_1: null,
          row_311_1_2: [],
          row_311_2_1: null,
          row_311_2_2: [],
          row_311_3_1: null,
          row_311_3_2: [],
          row_311_4_1: null,
          row_311_4_2: [],

          row_312_1_1: null,
          row_312_1_2: [],
          row_312_2_1: null,
          row_312_2_2: [],
          row_312_3_1: null,
          row_312_3_2: [],
          row_312_4_1: null,
          row_312_4_2: [],

          row_321_1_1: null,
          row_321_1_2: [],
          row_321_2_1: null,
          row_321_2_2: [],
          row_321_3_1: null,
          row_321_3_2: [],
          row_321_4_1: null,
          row_321_4_2: [],

          row_322_1_1: null,
          row_322_1_2: [],
          row_322_2_1: null,
          row_322_2_2: [],
          row_322_3_1: null,
          row_322_3_2: [],
          row_322_4_1: null,
          row_322_4_2: [],
          meta:
            {
              add: ['row_111_1_1', 'row_111_2_1', 'row_111_3_1', 'row_111_4_1',
                'row_112_1_1', 'row_112_2_1', 'row_112_3_1', 'row_112_4_1',
                'row_121_1_1', 'row_121_2_1', 'row_121_3_1', 'row_121_4_1',
                'row_122_1_1', 'row_122_2_1', 'row_122_3_1', 'row_122_4_1',
                'row_131_1_1', 'row_131_2_1', 'row_131_3_1', 'row_131_4_1',
                'row_132_1_1', 'row_132_2_1', 'row_132_3_1', 'row_132_4_1',
                'row_141_1_1', 'row_141_2_1', 'row_141_3_1', 'row_141_4_1',
                'row_142_1_1', 'row_142_2_1', 'row_142_3_1', 'row_142_4_1',
                'row_211_1_1', 'row_211_2_1', 'row_211_3_1', 'row_211_4_1',
                'row_212_1_1', 'row_212_2_1', 'row_212_3_1', 'row_212_4_1',
                'row_221_1_1', 'row_221_2_1', 'row_221_3_1', 'row_221_4_1',
                'row_222_1_1', 'row_222_2_1', 'row_222_3_1', 'row_222_4_1',
                'row_231_1_1', 'row_231_2_1', 'row_231_3_1', 'row_231_4_1',
                'row_232_1_1', 'row_232_2_1', 'row_232_3_1', 'row_232_4_1',
                'row_241_1_1', 'row_241_2_1', 'row_241_3_1', 'row_241_4_1',
                'row_242_1_1', 'row_242_2_1', 'row_242_3_1', 'row_242_4_1',
                'row_251_1_1', 'row_251_2_1', 'row_251_3_1', 'row_251_4_1',
                'row_252_1_1', 'row_252_2_1', 'row_252_3_1', 'row_252_4_1',
                'row_261_1_1', 'row_261_2_1', 'row_261_3_1', 'row_261_4_1',
                'row_262_1_1', 'row_262_2_1', 'row_262_3_1', 'row_262_4_1',
                'row_271_1_1', 'row_271_2_1', 'row_271_3_1', 'row_271_4_1',
                'row_272_1_1', 'row_272_2_1', 'row_272_3_1', 'row_272_4_1',
                'row_281_1_1', 'row_281_2_1', 'row_281_3_1', 'row_281_4_1',
                'row_282_1_1', 'row_282_2_1', 'row_282_3_1', 'row_282_4_1',
                'row_311_1_1', 'row_311_2_1', 'row_311_3_1', 'row_311_4_1',
                'row_312_1_1', 'row_312_2_1', 'row_312_3_1', 'row_312_4_1',
                'row_321_1_1', 'row_321_2_1', 'row_321_3_1', 'row_321_4_1',
                'row_322_1_1', 'row_322_2_1', 'row_322_3_1', 'row_322_4_1'],
              set: ['row_111_1_2', 'row_111_2_2', 'row_111_3_2', 'row_111_4_2',
                'row_112_1_2', 'row_112_2_2', 'row_112_3_2', 'row_112_4_2',
                'row_121_1_2', 'row_121_2_2', 'row_121_3_2', 'row_121_4_2',
                'row_122_1_2', 'row_122_2_2', 'row_122_3_2', 'row_122_4_2',
                'row_131_1_2', 'row_131_2_2', 'row_131_3_2', 'row_131_4_2',
                'row_132_1_2', 'row_132_2_2', 'row_132_3_2', 'row_132_4_2',
                'row_141_1_2', 'row_141_2_2', 'row_141_3_2', 'row_141_4_2',
                'row_142_1_2', 'row_142_2_2', 'row_142_3_2', 'row_142_4_2',
                'row_211_1_2', 'row_211_2_2', 'row_211_3_2', 'row_211_4_2',
                'row_212_1_2', 'row_212_2_2', 'row_212_3_2', 'row_212_4_2',
                'row_221_1_2', 'row_221_2_2', 'row_221_3_2', 'row_221_4_2',
                'row_222_1_2', 'row_222_2_2', 'row_222_3_2', 'row_222_4_2',
                'row_231_1_2', 'row_231_2_2', 'row_231_3_2', 'row_231_4_2',
                'row_232_1_2', 'row_232_2_2', 'row_232_3_2', 'row_232_4_2',
                'row_241_1_2', 'row_241_2_2', 'row_241_3_2', 'row_241_4_2',
                'row_242_1_2', 'row_242_2_2', 'row_242_3_2', 'row_242_4_2',
                'row_251_1_2', 'row_251_2_2', 'row_251_3_2', 'row_251_4_2',
                'row_252_1_2', 'row_252_2_2', 'row_252_3_2', 'row_252_4_2',
                'row_261_1_2', 'row_261_2_2', 'row_261_3_2', 'row_261_4_2',
                'row_262_1_2', 'row_262_2_2', 'row_262_3_2', 'row_262_4_2',
                'row_271_1_2', 'row_271_2_2', 'row_271_3_2', 'row_271_4_2',
                'row_272_1_2', 'row_272_2_2', 'row_272_3_2', 'row_272_4_2',
                'row_281_1_2', 'row_281_2_2', 'row_281_3_2', 'row_281_4_2',
                'row_282_1_2', 'row_282_2_2', 'row_282_3_2', 'row_282_4_2',
                'row_311_1_2', 'row_311_2_2', 'row_311_3_2', 'row_311_4_2',
                'row_312_1_2', 'row_312_2_2', 'row_312_3_2', 'row_312_4_2',
                'row_321_1_2', 'row_321_2_2', 'row_321_3_2', 'row_321_4_2',
                'row_322_1_2', 'row_322_2_2', 'row_322_3_2', 'row_322_4_2']
            }
        }
    },
    defaultData_it_010: {
      table4:
        [{
          department: '',
          coll_1: null,
          coll_2: null
        }
        ],
      table5:
        [{
          department: '',
          coll_1: null,
          coll_2: null
        }
        ],
      table6:
        [{
          department: '',
          coll_1: null,
          coll_2: null,
          coll_3: null,
          coll_4: null,
          coll_5: null,
          coll_6: null,
          coll_7: null,
          coll_8: null,
          coll_9: null
        }
        ],
      table7:
        [{
          department: '',
          coll_1: null,
          coll_2: null,
          coll_3: null,
          coll_4: null
        }
        ],
      table8:
        [{
          department: '',
          coll_1: null,
          coll_2: null
        }
        ],
      table9:
        [{
          department: '',
          coll_1: null,
          coll_2: null,
          coll_3: null,
          coll_4: null,
          coll_5: null,
          coll_6: null,
          coll_7: null,
          coll_8: null,
          coll_9: null,
          coll_10: null
        }
        ],
      table10:
        [{
          department: '',
          coll_1: null,
          coll_2: null,
          coll_3: null
        }
        ]
    },
    defaultData_monitoring_op_001: {
      dict1:
        {
          department: '',
          mum_division: '',
          row_1p0_3: null,
          row_1p1_3: null,
          row_1p2_3: null,
          row_1p3_3: null,
          row_1p4p1_3: null,
          row_1p4p2p1_3: null,
          row_1p4p2p2_3: null,
          row_1p4p2p3_3: null,
          row_1p5p1_3: null,
          row_1p5p2_3: null,
          row_1p5p3_3: null,
          row_1p5p4_3: null,
          row_1p5p5_3: null,
          row_1p5p6_3: null,
          row_1p5p7_3: null,
          row_1p5p8_3: null,
          row_1p5p9_3: null,
          row_1p6p1_3: null,
          row_1p6p2_3: null,
          row_1p6p3_3: null,
          row_1p6p4_3: null,
          row_1p7_3: null,
          row_1p8_3: null,
          row_1p9_3: null,
          row_1p10_3: null,
          row_2p2p1_3: null,
          row_2p2p2p1_3: null,
          row_2p2p2p2_3: null,
          row_2p2p3p1_3: null,
          row_2p2p3p2_3: null,
          row_3_3: null,
          row_4p1_3: null,
          row_4p2_3: null,
          row_4p3_3: null,
          row_4p4_3: null
        }
    },
    reportTypeDepartmentList: {},
    reportTypeDepartment: { id: null },
    defaultReportTypeDepartment: {
      id: null,
      report_department_id: null,
      report_department_info: {
        name_short: '--'
      }
    },
    departments: { 'results': [] }
  },
  mutations: {
    setReports (state, payload) {
      state.reports = payload
    },
    setStatuses (state, payload) {
      state.statuses = payload
    },
    setTypes (state, payload) {
      state.types = payload
    },
    setReport (state, payload) {
      state.report = payload
      // state.person.birthday = state.person.birthday.substr(0, 10)
    },
    setDefaultReport (state, payload) {
      state.report = Object.assign({}, state.defaultReport)
      Vue.set(state.report, 'typeAbbr', payload.typeAbbr)
      if (payload.typeAbbr === 'monitoring_msss_02') {
        state.report.data = Object.assign({}, JSON.parse(JSON.stringify(state.defaultData_monitoring_msss_02)))
      }
      if (payload.typeAbbr === 'one_001') {
        state.report.data = Object.assign({}, JSON.parse(JSON.stringify(state.defaultData_one_001)))
      }
      if (payload.typeAbbr === 'form_001') {
        state.report.data = Object.assign({}, JSON.parse(JSON.stringify(state.defaultData_form_001)))
      }
      if (payload.typeAbbr === 'form_002') {
        state.report.data = Object.assign({}, JSON.parse(JSON.stringify(state.defaultData_form_002)))
      }
      if (payload.typeAbbr === 'form_003') {
        state.report.data = Object.assign({}, JSON.parse(JSON.stringify(state.defaultData_form_003)))
      }
      if (payload.typeAbbr === 'it_001') {
        state.report.data = Object.assign({}, JSON.parse(JSON.stringify(state.defaultData_it_001)))
      }
      if (payload.typeAbbr === 'it_002') {
        state.report.data = Object.assign({}, JSON.parse(JSON.stringify(state.defaultData_it_002)))
      }
      if (payload.typeAbbr === 'it_003') {
        state.report.data = Object.assign({}, JSON.parse(JSON.stringify(state.defaultData_it_003)))
      }
      if (payload.typeAbbr === 'it_010') {
        state.report.data = Object.assign({}, JSON.parse(JSON.stringify(state.defaultData_it_010)))
      }
      if (payload.typeAbbr === 'monitoring_op_001') {
        state.report.data = Object.assign({}, JSON.parse(JSON.stringify(state.defaultData_monitoring_op_001)))
      }
    },
    setReportTypeDepartmentList (state, payload) {
      state.reportTypeDepartmentList = payload
    },
    setReportTypeDepartment (state, payload) {
      state.reportTypeDepartment = payload
    },
    setReportTypeDepartment2 (state, payload) {
      Vue.set(state.reportTypeDepartment, 'report_department_id', payload.report_department_id)
      Vue.set(state.reportTypeDepartment.report_department_info, 'name_short', payload.report_department_name_short)
    },
    setDefaultReportTypeDepartment (state, payload) {
      state.reportTypeDepartment = Object.assign({}, JSON.parse(JSON.stringify(state.defaultReportTypeDepartment)))
      Vue.set(state.reportTypeDepartment, 'id', payload.id)
      Vue.set(state.reportTypeDepartment, 'type_abbr', payload.type_abbr)
    },
    setDepartments (state, payload) {
      state.departments = payload
    }
  },
  actions: {
    fetchReports ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingFetchReports'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = { type_abbr: payload.typeAbbr }
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        Object.keys(payload.report_search).forEach((key) => {
          params[key] = payload.report_search[key]
        })
        let _url = appURL + 'report/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setReports', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchStatuses ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingFetchStatuses'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'status/'
        session.get(_url)
          .then(response => {
            commit('setStatuses', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchTypes ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingFetchTypes'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'type/'
        session.get(_url)
          .then(response => {
            commit('setTypes', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchReport ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingFetchReport'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report/' + payload.id + '/'
        session.get(_url)
          .then(response => {
            commit('setReport', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertReport ({ commit, dispatch, getters }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingInsertReport_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let mumDivision = (('dict1' in payload.data) && ('mum_division' in payload.data['dict1'])) ? payload.data['dict1']['mum_division'] : ''
        const data = {
          'period': payload.period.substr(0, 7) + '-01',
          'status': payload.status,
          'type_abbr': payload.typeAbbr,
          'remark': payload.remark,
          'data': payload.data,
          'mum_division': mumDivision
        }

        let _url, method
        if (payload.id === null) {
          _url = appURL + 'report/'
          method = 'post'
        } else {
          _url = appURL + 'report/' + payload.id + '/'
          method = 'patch'
        }
        session({ method: method, url: _url, data: data }
        )
          .then(response => {
            commit('setReport', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deleteReport ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingDeleteReport_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report/' + payload + '/delete/'
        session.get(_url)
          .then(response => {
            // commit('setPerson', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    summaryReport ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingSummaryReport_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report/' + payload + '/summary/'
        session.get(_url)
          .then(response => {
            commit('setReport', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    duplicateReport ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingDuplicateReport_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report/' + payload + '/duplicate/'
        session.get(_url)
          .then(response => {
            commit('setReport', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    downloadFile ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingDownloadFile_' + payload.urlFile
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report/' + payload.id + '/' + payload.urlFile
        const download = require('js-file-download')
        session({ url: _url,
          method: 'GET',
          responseType: 'blob'
        })
          .then(response => {
            download(response.data,
              payload.filename,
              ('mime' in payload) ? payload.mime : 'application/octet-stream'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchReportTypeDepartmentList ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingFetchReportTypeDepartmentList'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = { type_abbr: payload.typeAbbr }
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        if (payload.search > '') {
          params['search'] = payload.search
        }
        let _url = appURL + 'report_type_department/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setReportTypeDepartmentList', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchReportTypeDepartmentCard ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingFetchReportTypeDepartmentCard_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report_type_department/' + payload.id + '/'
        session.get(_url)
          .then(response => {
            commit('setReportTypeDepartment', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchDepartmentList ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingFetchDepartmentList'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURLAccounts + 'department2/'
        let params = {}
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        if (payload.search > '') {
          params['search'] = payload.search
        }

        session.get(_url, { params: params })
          .then(response => {
            commit('setDepartments', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertReportTypeDepartment ({ commit, dispatch, getters }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingInsertReportTypeDepartment_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        const data = {
          'type_abbr': payload.type_abbr,
          'report_department': payload.report_department_id
        }
        let _url, method
        if (payload.id === 'new') {
          _url = appURL + 'report_type_department/'
          method = 'post'
        } else {
          _url = appURL + 'report_type_department/' + payload.id + '/'
          method = 'patch'
        }
        session({ method: method, url: _url, data: data }
        )
          .then(response => {
            commit('setReportTypeDepartment', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deleteReportTypeDepartment ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'reportingDeleteReportTypeDepartment_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report_type_department/' + payload + '/delete/'
        session.get(_url)
          .then(response => {
            // commit('setPerson', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    statuses (state) {
      return state.statuses
    },
    types (state) {
      return state.types
    },
    getStatus: (state) => (id) => {
      if (state.statuses.length === 0 || id === undefined) {
        return ''
      } else {
        return state.statuses.filter(item => item.id === id)[0].status_name
      }
    },
    getType: (state) => (typeAbbr) => {
      if (state.types.length === 0 || typeAbbr === undefined) {
        return { 'id': 0, 'abbr': 'not_report', 'report_name': 'Отчет не выбран' }
      } else {
        return state.types.filter(item => item.abbr === typeAbbr)[0]
      }
    },
    reports (state) {
      return state.reports
    },
    report_search (state) {
      return state.report_search
    },
    report (state) {
      return state.report
    },
    stateAll (state) {
      return state
    },
    reportTypeDepartmentList (state) {
      return state.reportTypeDepartmentList
    },
    reportTypeDepartment (state) {
      return state.reportTypeDepartment
    },
    fullReportTypeDepartment (state) {
      return state.reportTypeDepartment.id + ', ' + state.reportTypeDepartment.report_department_name_short
    },
    departments (state) {
      return state.departments
    },
    get_mum_divisions: (state) => (ogrn) => {
      const d = JSON.parse(JSON.stringify(state.mum_divisions))
      return d[ogrn]
    },
    getDataDefaultReport: (state) => (typeAbbr) => {
      // Возвращает копию переменной по умолчанию
      // Например: defaultData_it_010
      // где typeAbbr = 'it_010'
      return Object.assign({}, JSON.parse(JSON.stringify(state['defaultData_' + typeAbbr])))
    }
  }
}
